<template>
  <div class="plr16">
    <h1 class="bold fs-16 pb8 tl">{{ dataTitle }}</h1>
    <p class="pb16 fs-14">{{ dataDescription }}</p>
    <div class="d-flex justify-content-right align-items-center">
      <button class="astext pr16" @click="closeItemRemovePopup">
        <span :style="{ paddingLeft: dataPaddingLeft }">Cancel</span>
      </button>
      <button
        class="btn bold hand cta-remove secondary"
        @click="$emit('removeItemFromCart')"
      >
        <span :style="{ paddingLeft: dataPaddingLeft }">{{ dataAction }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import { keyMapsMutation } from "../helpers/storeKeys";
import { EVENT_CART_CLICK_REMOVE_LAST_ITEM } from "../helpers/analyticsEvents";
export default {
  name: "ItemRemovePopup",
  props: ["dataTitle", "dataDescription", "dataAction", "dataPaddingLeft"],
  mounted() {
    document.body.classList.add("body-stop-scroll-mobile");
    EVENT_CART_CLICK_REMOVE_LAST_ITEM({ userAction: "Launch" });
  },
  methods: {
    closeItemRemovePopup() {
      this.$store.commit(
        keyMapsMutation.UPDATE_REMOVE_ITEM_CART_POPUP_SELECTED,
        false
      );

      EVENT_CART_CLICK_REMOVE_LAST_ITEM({ userAction: "Close" });
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_ITEM_IN_CART, {});
      document.body.classList.remove("body-stop-scroll-mobile");
    },
  },
};
</script>
